import { gql } from '@apollo/client'
import type { Order } from '@ztechapps/common.contract'
import { useSubscription, type UseSubscriptionProps } from '@ztechapps/common.hook'
import { orderFragment, singleOrderQuery } from './graphql'

const defaultQuery = gql`
  ${orderFragment}
  subscription updatedOrder($filter: JSON) {
    updatedOrder(filter: $filter) {
      ...orderFragment
    }
  }
`

export type UseOrderUpdatedSubscriptionProps = {
  orderId: string
} & UseSubscriptionProps<{ updatedOrder: Order }>

export const useOrderUpdatedSubscription = ({ query, orderId, filter, ...props }: UseOrderUpdatedSubscriptionProps) => {
  query ??= defaultQuery
  filter ??= {
    _id: orderId,
  }

  return useSubscription<{ updatedOrder: Order }>({
    query,
    filter,
    cacheQuery: singleOrderQuery,
    entityName: 'order',
    ...props,
  })
}
